<template>

    <div class="faq">

        <header-green v-if="!isNativeUser"></header-green>

        <div class="search">

            <h1 class="search__title">{{ $t('new_faq_search_bar_title') }}</h1>

            <label class="search__container" for="inputSearch">

                <img class="search__img" src="/img/icons/search-fill.svg">

                <input id="inputSearch" ref="inputSearch" :placeholder="$t('new_faq_search_bar')" class="search__input" v-on:keyup.enter="search">

            </label>

            <img class="search__background-img-1" src="/img/static/faq/bosquet-2.svg">

            <img class="search__background-img-2" src="/img/static/faq/bosquet-1.svg">

        </div>

        <div>

            <div class="categories">

                <div v-for="(subject, subjectIndex) in faq" class="categories__category">

                    <img :src="subject.img" class="categories__img">

                    <h2 class="categories__title">{{ subject.title }}</h2>

                    <a v-if="getQuestionTitle(subjectIndex, 0)" :href="`#${getQuestionAnchor(subjectIndex, 0)}`" class="categories__subtitle">{{ getQuestionTitle(subjectIndex, 0) }}</a>

                    <a v-if="getQuestionTitle(subjectIndex, 1)" :href="`#${getQuestionAnchor(subjectIndex, 1)}`" class="categories__subtitle">{{ getQuestionTitle(subjectIndex, 1) }}</a>

                    <a v-if="getQuestionTitle(subjectIndex, 2)" :href="`#${getQuestionAnchor(subjectIndex, 2)}`" class="categories__subtitle">{{ getQuestionTitle(subjectIndex, 2) }}</a>

                    <a :href="`#${getTitleAnchor(subjectIndex)}`" class="categories__link">{{ $t('new_faq_view_all') }}</a>

                </div>


            </div>

            <div v-for="(subject, subjectIndex) in faq" :id="getTitleAnchor(subjectIndex)" :name="getTitleAnchor(subjectIndex)" class="central__container">

                <img :src="subject.img" class="central__img">

                <h2 class="central__title">{{ subject.title }}</h2>

                <div v-for="(question, questionIndex) in subject.questions" :id="getQuestionAnchor(subjectIndex, questionIndex)" class="central__collapsible"
                     @click="toggleItem(subjectIndex, questionIndex)">

                    <img :class="{'central__collapsible__img-reverse': faq[subjectIndex].questions[questionIndex].show }" class="central__collapsible__img" src="/img/icons/arrow-grey.svg">

                    <h3 class="central__collapsible__title">{{ question.ask }}</h3>

                    <markdown v-show="faq[subjectIndex].questions[questionIndex].show" :text="question.answer" class="central__collapsible__text"></markdown>

                </div>

            </div>

            <div class="help">

                <h2 class="help__title">{{ $t('new_faq_other_help') }}</h2>

                <a class="help__btn help__btn-blue" href="mailto:contact@cleanfox.io">

                    <p class="help__text">{{ $t('new_faq_give_opinion') }}</p>

                    <img class="help__img" src="/img/icons/arrow-square-up-right-fill.svg">

                </a>

                <a class="help__btn help__btn-green" href="mailto:contact@cleanfox.io">

                    <p class="help__text">{{ $t('new_faq_contact_support') }}</p>

                    <img class="help__img" src="/img/icons/arrow-square-up-right-fill.svg">

                </a>

            </div>


        </div>

        <footer-green v-if="!isNativeUser"></footer-green>

    </div>

</template>

<script>

import Vuex from 'vuex'

import I18n from '@/modules/i18n'
import UserFlow from '@/modules/userFlow'

import FooterGreen from '@/components/FooterGreen'
import HeaderGreen from '@/components/headers/HeaderGreen'
import Markdown from '@/components/Markdown'

import FaqFr from '@/assets/faq/fr.js'
import FaqEn from '@/assets/faq/en.js'

export default {

    name: 'faq',

    components: {FooterGreen, HeaderGreen, Markdown},

    watch: {

        lang: function () {
            this.loadContent()
        }

    },

    computed: {

        ...Vuex.mapGetters(['lang']),

        isNativeUser: function () {
            return this.$route.path.indexOf('/native/') > -1
        }

    },

    data() {
        return {
            faq: []

        }
    },

    created() {
        UserFlow.setPage(this, 'faq')
    },

    mounted() {

        this.loadContent()

        window.scrollTo(0, 0)
    },

    methods: {

        toggleItem(subjectIndex, questionIndex) {
            this.faq[subjectIndex].questions[questionIndex].show = !this.faq[subjectIndex].questions[questionIndex].show
            this.$forceUpdate()
        },

        loadContent() {

            I18n.get(this) === 'fr'
                ? this.faq = FaqFr
                : this.faq = FaqEn
        },

        search() {

            const toSearch = this.$refs.inputSearch.value

            this.faq.forEach((item, itemIndex) => {

                item.questions.forEach((question, questionIndex) => {
                    if (question.answer.indexOf(toSearch) > -1) {
                        this.faq[itemIndex].questions[questionIndex].show = true
                    }
                })

            })

            this.$forceUpdate()

            setTimeout(() => {

                find(this.$refs.inputSearch.value)

            }, 10)

        },

        getQuestionTitle(subjectIndex, questionIndex) {

            return this.faq[subjectIndex].questions && this.faq[subjectIndex].questions[questionIndex] && this.faq[subjectIndex].questions[questionIndex].ask
        },

        getTitleAnchor(index) {
            return `id-${index}`
        },

        getQuestionAnchor(subjectIndex, questionIndex) {
            return `question-${subjectIndex}-${questionIndex}`
        }
    }
}
</script>

<style lang="scss" scoped>

.faq {
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: $moon;
}

.search {
    padding: 170px 16px 225px;
    margin-top: 56px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    background-color: $forest;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 80px;
        padding: 96px 0;
    }

    &__title {
        font-size: 34px;
        font-weight: bold;
        line-height: 1.25;
        color: $white;
        z-index: 1;
        margin: 0;
    }

    &__container {
        position: relative;
        margin-top: 24px;
        width: 100%;
        max-width: 644px;
        height: 56px;
        border-radius: 32px;
        background-color: $white;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-left: 56px;
        padding-right: 24px;
        z-index: 1;
    }

    &__img {
        position: absolute;
        left: 16px;
    }

    &__input {
        width: 100%;
        font-size: 17px;
        font-weight: 600;
        line-height: 1.4;
        color: $stone;
    }

    &__background-img-1 {
        position: absolute;
        bottom: 0;
        left: -20px;
        width: 110px;
        object-fit: contain;
        @media screen and (min-width: $above-tablet-length) {
            width: 180px;
            left: 95px;
        }
    }

    &__background-img-2 {
        position: absolute;
        bottom: 0;
        right: -30px;
        object-fit: contain;
        width: 100px;
        @media screen and (min-width: $above-tablet-length) {
            width: 222px;
            right: 64px;
        }
    }
}

.categories {
    padding: 44px 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: $above-tablet-length) {
        padding: 16px 64px 64px;
        align-items: baseline;
    }

    &__category {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-right: 24px;
        text-align: left;
        margin: 20px 0;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 48px;
            width: 33%;
        }
    }

    &__img {
        width: 64px;
        object-fit: contain;
    }

    &__title {
        margin-top: 24px;
        margin-bottom: 4px;
        font-size: 22px;
        font-weight: bold;
        line-height: 1.25;
        letter-spacing: -0.44px;
        color: $charcoal;
    }

    &__subtitle {
        margin-top: 12px;
        font-size: 17px;
        font-weight: 500;
        line-height: 1.25;
        letter-spacing: -0.34px;
        cursor: pointer;
        color: $moon;
    }

    &__link {
        margin-top: 12px;
        font-size: 17px;
        font-weight: 500;
        line-height: 1.5;
        letter-spacing: -0.34px;
        color: $forest;
        cursor: pointer;
    }

    &__link:hover {
        text-decoration: underline;
    }
}

.central {
    &__container {
        padding: 32px 16px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        @media screen and (min-width: $above-tablet-length) {
            padding: 64px;
        }
    }

    &__img {
        width: 64px;
        object-fit: contain;
    }

    &__title {
        font-size: 34px;
        font-weight: bold;
        line-height: 1.25;
        color: $charcoal;
        margin: 24px 0;
        @media screen and (min-width: $above-tablet-length) {
            margin: 36px 0 40px;
        }
    }

    &__collapsible {
        padding: 26px 24px;
        width: 100%;
        max-width: 644px;
        overflow: hidden;
        border-radius: 20px;
        border: solid 4px $timberwolf;
        margin: 8px 0;
        position: relative;

        &__img {
            position: absolute;
            width: 32px;
            top: 24px;
            right: 24px;
            transform: rotate(270deg);
            opacity: 0.5;
        }

        &__img-reverse {
            transform: rotate(90deg);
        }

        &__title {
            margin: 0 56px 0 0;
            text-align: left;
            font-size: 22px;
            font-weight: 500;
            line-height: 1.25;
            color: $charcoal;
        }

        &__text {
            margin-top: 16px;
            font-size: 17px;
            line-height: 1.5;
            color: $charcoal;
            text-align: left;
        }
    }
}

.help {
    padding: 32px 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    @media screen and (min-width: $above-tablet-length) {
        padding-bottom: 120px;
    }

    &__title {
        font-size: 34px;
        font-weight: bold;
        line-height: 1.25;
        letter-spacing: normal;
        color: $charcoal;
        margin-bottom: 24px;
        @media screen and (min-width: $above-tablet-length) {
            margin-bottom: 40px;
        }
    }

    &__btn {
        width: 100%;
        position: relative;
        display: flex;
        padding: 24px 88px 24px 24px;
        border-radius: 16px;
        margin: 8px 0;
        align-items: center;
        cursor: pointer;
        max-width: 644px;
    }

    &__btn-blue {
        background-color: #1da1f2;
    }

    &__btn-green {
        background-color: $forest;
    }

    &__text {
        font-size: 22px;
        font-weight: bold;
        line-height: 1.25;
        letter-spacing: -0.44px;
        color: $white;
        text-align: left;
    }

    &__img {
        position: absolute;
        right: 24px;
        width: 48px;
        object-fit: contain;
    }
}


</style>


<!--unscoped-->
<style lang="scss">
.central__collapsible__text p {
    margin: revert;
}
</style>
